module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c5a70a659d7400ca36c753f5ea7afd33.png";